@import '../../sass/base/variables';
@import '../../sass/variables/buttons';
@import '../../sass/base/mixins';
@import '../../sass/mixins/links';
@import '../../sass/mixins/border-radius';
@import '../../sass/mixins/transition';
@import '../../sass/mixins/buttons';

/**
*  List Parent Item Mixins
*/

@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
    display:block;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}


@keyframes slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(100%, 0, 0);
  }
}


/** 
*  Sidebar Styles
**/
:host[type="sidebar"] {
  som-accordion::part(label) {
    @include text-type(6, 500);
    text-align: left;
    letter-spacing: 1px;
    white-space: normal;
    vertical-align: middle;
    user-select: none;
    color: $header-copy;
  }

  som-accordion::part(button) {
    padding: .5rem .5rem .5rem 1.5rem;
    margin:0;
  }

  som-accordion::part(button):focus-visible {
    background-color: $smoke;
  }

  som-accordion::part(button-open) {
    background: none
  }      

  som-accordion::part(button-open):hover {
    background-color: $smoke;
  }

  som-accordion::part(accordion) {
    border: none;
  }

  som-accordion::part(arrow) {
    font-size: 1.25rem;
  }
}

:host[type="panel"] {
  som-accordion::part(label) {
    @include text-type(5, 500);
    text-align: left;
    letter-spacing: 1px;
    white-space: normal;
    vertical-align: middle;
    user-select: none;
    color: $header-copy;
  }
  
  som-accordion::part(button) { 
    padding: .75rem .75rem .75rem 1rem;
    margin:0;
  }
  
  som-accordion::part(button):focus-visible {
    background-color: $smoke;
  }
  
  som-accordion::part(button-open) {
    background: none
  }      
  
  som-accordion::part(button-open):hover {
    background-color: $smoke;
  }
  
  som-accordion::part(accordion) {
    border: none;
  }
  
  som-accordion::part(arrow) {
    font-size: 1.25rem;
  }

  .panel-child-container {
    border-top: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
  }
}

/**
* List Parent Item Styles
*/
.list-parent-item {
  &.header {
    display: flex;
    align-items: center;
    height: 100%;
  }

  &__link {
    @include panel-list-link;
    display:flex;
    justify-content: space-between;
  }

  &__children {
    top:0;
    height: 100%;
    width: 100%;
    position: absolute;
    background: white;
  }
}